module.exports = __webpack_public_path__ + "static/media/user.e03143c3.svg";